import React, { useState, useEffect } from 'react';
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../../services/api/API';
import { showCustomAlert } from '../../../../../customComponents/CustomSweetAlert';
import Loader from '../../../../../customComponents/CustomLoader';
import Swal from 'sweetalert2';

const EditDealerBranch = () => {
  const [formData, setFormData] = useState({});
  const [dealerOptions, setDealerOptions] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [ dealerbranch, setdealerbranch ] = useState([])
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")
  const dealerId = localStorage.getItem("dealerId")
  const dealerType = localStorage.getItem("UserType")

  useEffect(() => {
    userTypedropdown()
  },[])
  
  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })
  
      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }



  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    fetchDealerbranchEdit()
  },[])



  const fetchDealerbranchEdit = async () => {
    try{
      const response = await axiosInstance.get(`/showroom/edit/${data.showroom_id}`,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
        },
    })
    const fetchedData = response.data.data;
    console.log(fetchedData, "FETCHEDDATA")
    const transformedData = {
      dealer_id: fetchedData.dealer_id,
        branch_name: fetchedData.showroom_name,
        branch_desc: fetchedData.showroom_desc,
        contact_no: fetchedData.contact_no,
        pincode: fetchedData.showroom_pincode,
        branch_country: fetchedData.country_id,
        branch_state: fetchedData.state_id,
        branch_city: fetchedData.city_id,
        branch_address: fetchedData.showroom_address,
        email_id: fetchedData.emailid,
        tin: fetchedData.tin,
        panno: fetchedData.pan,
        gstno: fetchedData.gst,
        status: fetchedData.status === 1 ? "Active" : "Inactive",
      business_partner_id:fetchedData.business_partner_id,
    }
    setFormData(transformedData)
    setdealerbranch(fetchedData)
    console.log(formData, "depatartment DATA")
  
  }catch(error){
      console.log(error)
    }
  
  }

  useEffect(() => {
    fetchDealerOptions()
  },[])

  const fetchDealerOptions = async () => {
    try {
      const response = await axiosInstance.post('/dealer/list',
        {
          orderBy: "dealer_id desc",
          business_partner_id: 1
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          }
        });

      const options = response.data.data.data.map(dealer => ({
        label: dealer.dealer_name,
        value: dealer.dealer_id
      }));
      setDealerOptions(options);
    } catch (error) {
      console.error('Error fetching dealer options:', error);
    }
  };

  const handlePincodeChange = async (pincode) => {
    try {
      const response = await axiosInstance.get(`/pincode/${pincode}`);

      const { city, state, country } = response.data;
      setFormData({
        ...formData,
        branch_city: city,
        branch_state: state,
        branch_country: country
      });
    } catch (error) {
      console.error('Error fetching pincode details:', error);
    }
  };

  // const fetchDealerBrancheEdit = async () => {
  //   try{
  //     const response = await axiosInstance.get(`/showroom/edit/`)
  //   }catch(error) {
  //     console.log(error, "error")
  //   }
  // }

  const DealerBranchInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: {
              required: true,
              pattern: /^[A-Za-z0-9 ]*$/,
              message: "Only alphabets and digits are allowed",
            },
          },
        ]
      : []),

      ...(dealerType !== "dealeruser"
        ? [
          {
            name: "dealer_id",
            label: "Dealer Name",
            type: "dropdown",
            required: true,
            options: dealerOptions,
            gridClass: "col-lg-4",
            validation: { required: true,
              pattern: /^[A-Za-z0-9 ]*$/,
              message: "Only alphabets and digits are allowed",
             },
          }
        ]
        : []
      ),
    // {
    //   name: "dealerName",
    //   label: "Dealer Name",
    //   type: "dropdown",
    //   required: true,
    //   options: dealerOptions,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    {
      name: "branch_name",
      label: "Dealer Branch Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "branch_desc",
      label: "Dealer Branch Desc",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "contact_no",
      label: "Contact No",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { 
        required: true, pattern: /^[6-9]/ ,
        minLength:10,
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      }
    },
    {
      name: "pincode",
      label: "Pin Code",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },

    },
    {
      name: "country",
      label: "Country",
      type: "text",
      required: true,
      disabled:true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "state",
      label: "State",
      type: "text",
      required: true,
      disabled:true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "city",
      label: "City",
      type: "text",
      required: true,
      disabled:true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "branch_address",
      label: "Branch Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "email_id",
      label: "Email Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "tin",
      label: "TIN NO",
      type: "text",
      placeholder: "Enter Tin No.",
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
    },
      {
    name: "panno",
    label: "PAN No.",
    type: "text",
    placeholder: "Enter PAN No.",
    validation: { 
      // required: true, 
      pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 
      message: "Please enter a valid 10-character PAN number"
    },
    // required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "gstno",
    label: "GST No.",
    type: "text",
    placeholder: "Enter GST No.",
    validation: { 
      // required: true, 
      pattern: /^\d{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/, 
      message: "Please enter a valid 15-character GST number"
    },
    // required: true,
    gridClass: "col-lg-4",
  },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
  ];
  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    DealerBranchInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to edit this Dealer Branch?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
       // Reverse the position of confirm/cancel buttons
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true); 
  
        try {
          const payload = {
            contact_no: formData.contact_no,
            showroom_name: formData.branch_name,
            showroom_desc: formData.branch_desc,
            showroom_address: formData.branch_address,
            emailid: formData.email_id,
            showroom_pincode: formData.pincode,
            country_id: formData.country_id,
            state_id: formData.state_id,
            city_id: formData.city_id,
            tin: formData.tin,
            pan: formData.pan,
            gst: formData.gst,
            status: formData.status === "Active" ? 1 : 0,
          };
  
          if (userType !== "dealeruser") {
            payload.dealer_id = formData?.dealer_id;
          } else {
            payload.dealer_id = dealerId;
          }
  
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
  
          const response = await axiosInstance.patch(
            `/showroom/update/${data.showroom_id}`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
          Swal.fire({
            title: "Success",
            text: "Dealer Branch updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            navigate('/admin/manage-dealer/dealer-branch'); // Navigate after user clicks OK
          });
  
        } catch (error) {
          const errorMessage = error.response?.data?.message || "An error occurred while updating the dealer branch.";
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
  
          console.error("Error updating dealer branch:", error);
        } finally {
          setLoading(false); // Stop loading regardless of success or failure
        }
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Your changes were not saved.",
          icon: "info",
          confirmButtonText: "OK",
        });
        setLoading(false); // Stop loading when the user cancels
      }
    });
  };
  
  
  return (
    <>
      {loading ? (
          <Loader />
        ) : (
          <>
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Edit Dealer Branch</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Dealer Branch Details
        </span>
        <DynamicForm
          formConfig={DealerBranchInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            handleFormSubmit(formData);
          }}
          className="submit-btn"
        >
          Submit
        </button>
      </div></>
        )}
    </>
  );
};

export default EditDealerBranch;
